import { ElementType } from 'react'
import DashboardIcon from '@rsuite/icons/Dashboard'
import PageIcon from '@rsuite/icons/Page'
import TaskIcon from '@rsuite/icons/Task'
import PeoplesIcon from '@rsuite/icons/Peoples'
import BranchIcon from '@rsuite/icons/Branch'
import TreeIcon from '@rsuite/icons/Tree'
import ListIcon from '@rsuite/icons/List'
import FunnelIcon from '@rsuite/icons/Funnel'
import { ROUTES } from 'routers/Routes'

export type NavItem = {
  id: string
  name: string
  link: string
  icon: ElementType
  /** Highlight only on this exact path (for routes that prefix others). */
  exact?: boolean
}

export type NavGroup = {
  id: string
  label: string
  items: NavItem[]
}

/** Side navigation, grouped like FinAIQ: daily work first, then setup. */
const navGroups: NavGroup[] = [
  {
    id: 'workspace',
    label: 'Workspace',
    items: [
      {
        id: 'dashboard',
        name: 'Dashboard',
        link: ROUTES.DASHBOARD,
        icon: DashboardIcon,
        exact: true
      },
      {
        id: 'documents',
        name: 'Documents',
        link: ROUTES.DOCUMENTS,
        icon: PageIcon
      },
      { id: 'tasks', name: 'Tasks', link: ROUTES.CLIENT_TASK, icon: TaskIcon }
    ]
  },
  {
    id: 'setup',
    label: 'Setup',
    items: [
      {
        id: 'clients',
        name: 'Clients',
        link: ROUTES.CLIENT,
        icon: PeoplesIcon
      },
      {
        id: 'integrations',
        name: 'Integrations',
        link: ROUTES.CLIENT_INTEGRATION,
        icon: BranchIcon
      },
      {
        id: 'rule-configuration',
        name: 'Rule configuration',
        link: ROUTES.CLIENT_RULE_CONFIGRATION,
        icon: TreeIcon
      },
      { id: 'rules', name: 'Rules', link: ROUTES.CLIENT_RULES, icon: ListIcon },
      {
        id: 'thresholds',
        name: 'Thresholds',
        link: ROUTES.CLIENT_THRESHOLDS,
        icon: FunnelIcon
      }
    ]
  }
]

/** The item to highlight: the longest link that matches the current path. */
export const activeNavItemId = (pathname: string) => {
  let best: NavItem | undefined
  navGroups.forEach((group) =>
    group.items.forEach((item) => {
      const matches = item.exact
        ? pathname === item.link
        : pathname === item.link || pathname.startsWith(`${item.link}/`)
      if (matches && (!best || item.link.length > best.link.length)) {
        best = item
      }
    })
  )
  return best?.id
}

export default navGroups
